import qs from 'query-string';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import ViewReportCell from './ViewReportCell';
import DefaultPageLayout from '../../../components/DefaultPageLayout';
import SavedSearchesTable from '../../../components/SavedSearchesTable';
import { POWERBI_ENABLED_APP_SETTING } from '../../../constants/PowerBIConstants';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getAppSettingsByKey } from '../../../selectors/AppConfigsSelectors';
import { isTrue } from '../../../utils/commonUtils';

const PowerBIReportsPage = ({ location }) => {
  const translateString = useTranslation();

  const isPowerBIEnabled = useSelector(getAppSettingsByKey(POWERBI_ENABLED_APP_SETTING));

  const { moduleName, entityName, searchName } = qs.parse(location.search);

  const pageTitle = moduleName
    ? `${moduleName} ${translateString('Reports')}`
    : translateString('Reports');

  useEffect(() => {
    document.title = pageTitle;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageTitle]);

  const customFilter = [
    {
      openGroup: true,
      fieldName: 'QI_MODULE_NAME',
      sqlOperator: 'CT',
      value: moduleName,
      relationalOperator: 'AND',
      closeGroup: true,
    },
  ];

  return (
    <DefaultPageLayout pageTitle={pageTitle}>
      {isTrue(isPowerBIEnabled) && (
        <SavedSearchesTable
          showSearchSelector={false}
          customCell={(column) => ({ row }) => <ViewReportCell column={column} row={row} />}
          entityName={entityName}
          enableSorting
          customFilter={customFilter}
          rowsPerPageOptions={[10, 25, 50]}
          initialSearchName={searchName}
          title={translateString('Reports')}
        />
      )}
    </DefaultPageLayout>
  );
};

export default PowerBIReportsPage;
